<template>
  <div id="vx-col w-full mb-base">
    <!-- PRODUCT TABLE -->
    <!-- <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir valider la supression du type de netlink ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="accept()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="decline()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
    <vx-card class="mt-1">
      <div class="vx-row">
        <div class="vx-col mb-2">
          <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })"
            >Nouveau Type de Netlink</vs-button
          >
        </div>
        <vs-spacer />
        <div class="vx-col mb-2">
          <vs-button icon-pack="feather" icon="icon-download-cloud" color="dark" @click="exportData(documents)">Exporter</vs-button>
        </div>
      </div>
    </vx-card> -->
    <vx-card class="mt-1">
      <div class="vx-row">
        <div class="vx-col">
          <h3>
            Filtres :
          </h3>
        </div>
        <div class="vx-col px-1 mb-2">
          <vs-input class="inputx" placeholder="Nom du document" v-model="documentNameFilter"  />
        </div>
        <div class="vx-col px-1 mb-2">
          <vs-select
            autocomplete
            v-model="documentTypeFilter"
            class="w-full select-large"
            placeholder="Catégorie du document"
          >
            <vs-select-item
            value=""
            text="Toutes les catégories"
            class="w-full"
            />
            <vs-select-item
            :key="index"
            :value="item.value + 1"
            :text="item.text"
            v-for="(item, index) in documentTypeOptions"
            class="w-full"
            />
          </vs-select>
        </div>
      </div>
            <div class="vx-row mt-2">
        <div class="vx-col">
          <strong>Nombre de résultats : {{ displayedDocuments.length }}</strong>
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-1" v-if="documents" style="max-height:69vh; overflow: auto;">
      <vs-table
        max-items="10"
        stripe
        :data="displayedDocuments"
      >
        <template slot="thead">
          <vs-th v-if="$acl.check('sadmin')">Ajouté par</vs-th>
			<vs-th sort-key="filename">Nom du document</vs-th>
			<vs-th sort-key="type_name">Type du document</vs-th>
			<vs-th sort-key="creation_date">Date</vs-th>
			<vs-th>Lien</vs-th>
          <!-- <vs-th>Type de prestation</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(tr, index) in data">
            <vs-td :id="'user' + tr.id" v-if="$acl.check('sadmin')">{{ getUserName(tr.user_id) }}</vs-td>
			<vs-td :id="'name' + tr.id">{{ tr.filename }}</vs-td>
			<vs-td :id="'type' + tr.id">{{ tr.type_name }}</vs-td>
			<vs-td>{{ getDate(tr.creation_date) }}</vs-td>
			<vs-td :id="'link' + tr.id">
				<vx-tooltip :text="tr.link" position="top">
					<vs-button
						size="large"
						color="primary"
						type="flat"
						icon-pack="feather"
						icon="icon-link-2"
						@click="openLink(tr.link)"
					></vs-button>
				</vx-tooltip>
			</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin";
import XLSX from "xlsx";
import VxCard from "../../components/widgets/vx-card/VxCard.vue";
import VueCookies from "vue-cookies";

export default {
	components: {VxCard},
	name: "DocumentsDashboard",
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			documents: [],
			selectedContract: null,
			showContractPopup: false,
			documentTypeFilter: "",
			documentTypeFilterOn: false,
			documentNameFilter: "",
			documentNameFilterOn: false,
			documentTypeOptions: [
				{text: "Audits & Etudes", value: 1},
				{text: "Rapports périodiques", value: 2},
				{text: "Devis et Contrat", value: 3},
				{text: "Divers", value: 4},
			],
			isDnsOptions: [
				{text: "Netlink Non-NDD", value: 0},
				{text: "Netlink NDD", value: 1},
			],
			displayedDocuments: [],
			displayedDocumentsFull: [],
			showValidationPopup: false,
			netlinkTypeToDelete: null,
		};
	},
	async created() {
		this.$store.dispatch("getAllUsers");
		if(this.selectedUserSociety){
			this.documents = await this.getSocietyDocuments(this.selectedUserSociety.id);
			this.displayedDocuments = this.documents;
			this.displayedDocumentsFull = this.documents;
		}
	},
	mounted() {
		/*
		 * this.displayedDocuments = this.documents;
		 * this.displayedDocumentsFull = this.documents;
		 */
	},
	watch: {
		selectedUserSociety: async function(data){
			this.documents = await this.getSocietyDocuments(data.id);
			this.displayedDocuments = this.documents;
			this.displayedDocumentsFull = this.documents;
		},
		documentTypeFilter: function() {
			if(this.documentTypeFilter == "") {
				this.documentTypeFilterOn = false;
			}
			else{
				this.documentTypeFilterOn = true;
			}
			////console.log("documentTypeFilter")
			this.displayedDocuments = this.filterSharedDocuments(this.displayedDocumentsFull);
		},
		documentNameFilter: function() {
			if(this.documentNameFilter == "") {
				this.documentNameFilterOn = false;
			}
			else{
				this.documentNameFilterOn = true;
			}
			////console.log("deliveryFilter")
			this.displayedDocuments = this.filterSharedDocuments(this.displayedDocumentsFull);
		},
	},
	computed: {
		activeUser(){
			return VueCookies.get("userInfo");
		},
		selectedUserSociety: () => {
			return store.state.activeUserSociety;
		},
		users: () => {
			return store.state.users;
		},
	},

	methods: {
		getDate(date){
			if(date) {
				return date.substring(0, 10).split("-").reverse().join("/");
			}
			else{
				return "";
			}
		},
		openLink(link){
			window.open(link, "_blank");
		},
		getUserName(user_id){
			let foundUser = this.users.findIndex(row => row.id == user_id);
			let userName = " ";
			if(foundUser >= 0) userName = this.users[foundUser].firstname + " " + this.users[foundUser].lastname;
			return userName;
		},
		getSocietyDocuments(society_id){
			return new Promise((resolve, reject) => {
				this.$http.get(this.apiUrl + "shared_document/list/society/" + society_id)
					.then((result) => {
						resolve(result.data);
					})
					.catch((err) => {
						//console.log("err", err);
						reject(err);
					});
			});

		},
		getAllNetlinkTypes() {
			this.$store.dispatch("getAllNetlinkTypes");
		},
		isFilterSet(){
			////console.log("isFilterSet BEGIN")
			if(this.documentNameFilterOn || this.documentTypeFilterOn) return true;
			return false;
		},


		filterSharedDocuments(documents){
			////console.log("filterProviders BEGIN")
			let sharedDocumentList = [];
			let searchKeyList = {};


			if(this.documentTypeFilterOn){
				searchKeyList["documentTypeFilter"] = this.documentTypeFilter;
			}

			if(this.documentNameFilterOn){
				searchKeyList["documentNameFilter"] = this.documentNameFilter.toLowerCase();
			}

			// //console.log("searchKeyList", searchKeyList)
			for(let sharedDocumentToFilter of documents){

				let sharedDocumentSearchKeyList = {};
				this.documentTypeFilterOn ? sharedDocumentSearchKeyList["documentTypeFilter"] = sharedDocumentToFilter.document_type_id : false;
				this.documentNameFilterOn ? sharedDocumentSearchKeyList["documentNameFilter"] = sharedDocumentToFilter.filename.toLowerCase() : false;

				let check = true;

				for(let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof sharedDocumentSearchKeyList[key])
					 */
					if(typeof searchKeyList[key] == "string"){
						if(typeof sharedDocumentSearchKeyList[key] == "string"){
							if(!sharedDocumentSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else if(typeof sharedDocumentSearchKeyList[key] == "object"){
							////console.log("Array")
							let checkLoop = false;
							for(let value of sharedDocumentSearchKeyList[key]){
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if(service_name.includes(searchKeyList[key])){
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if(!checkLoop){
								check = checkLoop;
								break;
							}
						}
					}
					else{
						if(sharedDocumentSearchKeyList[key] != searchKeyList[key] - 1){
							check = false;
							break;
						}
					}
				}

				if(check) sharedDocumentList.push(sharedDocumentToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			return sharedDocumentList;
		},

		deleteNetlinkType(netlinkTypeId){
			//console.log(netlinkTypeId);
			this.$http.delete(this.apiUrl + "netlink/type/delete/" + netlinkTypeId).then((err, result) => {
				if(err) //console.log(err);
				if(result) {
					//console.log(result);
					/*
					 * this.displayedDocumentsFull = this.displayedDocumentsFull.filter(function(element){
					 *   return element.id != product.id
					 * });
					 * this.displayedDocuments = this.displayedDocumentsFull
					 */
				}
			});
		},

		displayValidationPopup(netlinkType){
			this.netlinkTypeToDelete = netlinkType;
			this.showValidationPopup = true;
		},

		accept(){
			this.deleteNetlinkType(this.netlinkTypeToDelete.id);
			this.showValidationPopup = false;
		},

		decline(){
			this.netlinkTypeToDelete = null;
			this.showValidationPopup = false;
		},
		exportData(dataIn){
			let data = JSON.parse(JSON.stringify(dataIn));

			for(let i = 0; i < data.length; i++){
				// this.$delete(data[i],"is_netlink");
				data[i]["recurrency"] = data[i]["recurrency"] > 0 ? "Oui" : "Non";
				data[i]["is_dns"] = data[i]["is_dns"] > 0 ? "Oui" : "Non";
			}
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "";

			let header = {
				header: [
					"id",
					"name",
					"recurrency",
					"is_dns",
					"description",
				],
				skipHeader: true,
				origin: -1
			};

			let header_names = [{
				id: "Identifiant",
				name: "Nom du Type de Netlink",
				recurrency: "Récurrence",
				is_dns: "Est Lien NDD ?",
				description: "Description",
			}];


			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Types-de-Netlink_export.xls");
		},
	}

};
</script>

<style scoped>
.fw-bold {
  font-weight: bold;
  color: black;
}

.center {
  justify-content: center;
}
</style>
